import React, { useState, useEffect } from "react";

import survivorshipBusinessRulesHistoriesApi from "apis/survivorshipBusinessRulesHistories";
import { Table, Pagination } from "clearsense-ui/components";

import {
  SURVIVORSHIP_BUSINESS_RULES_HISTORY_COLUMNS,
  PAGE_SIZE_OPTIONS,
} from "../../../constants";

const HistoryTable = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sort, setSort] = useState("item_id::integer desc");

  const fetchHistory = async () => {
    setIsLoading(true);
    try {
      const params = {
        page: pageNumber,
        per_page: pageSize,
        sort,
      };
      const response =
        await survivorshipBusinessRulesHistoriesApi.fetchHistories({
          params,
        });
      setHistory(response.data.changes);
      setTotalRecords(response.data.total_count);
    } catch (error) {
      logger.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [pageSize, pageNumber, sort]);

  useEffect(() => {
    if (pageSize * pageNumber > history.length) {
      setPageNumber(1);
    }
  }, [pageSize]);

  const handleTableChange = sorter => {
    if (!sorter.order) {
      setSort("created_at desc");
    } else {
      setSort(`${sorter.field} ${sorter.order === "ascend" ? "asc" : "desc"}`);
    }
  };

  return (
    <>
      <Table
        fixedHeight
        columnData={SURVIVORSHIP_BUSINESS_RULES_HISTORY_COLUMNS}
        rowData={history.map(record => ({
          key: record.id,
          ...record,
        }))}
        loading={isLoading}
        onChange={(_pagination, _filters, sorter) => handleTableChange(sorter)}
      />
      <Pagination
        showResultsPerPage
        currentPage={pageNumber}
        pageSize={pageSize}
        totalRecordsCount={totalRecords}
        setCurrentPage={setPageNumber}
        setPageSize={setPageSize}
        pageSizeOptionsList={PAGE_SIZE_OPTIONS}
        className="cs-ui-table-background"
      />
    </>
  );
};

export default HistoryTable;
